import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../../../common_comp/Layout/Layout";

const Terms = () => {
  return (
    <Layout>
      <Container className="my-5   mx-auto ">
        <Row className="px-3    ">
          <h1 className="text-center fw-bold mb-4"> Terms and Conditions </h1>

          <ol>
            <li className="m-3">
              These terms and conditions ("the Terms") apply to this Green
              Publication website. By using this website you agree to be bound
              by the Terms which form a binding contract between you and Green
              Publication without prejudice to any rights you or Green may
              otherwise have at law. If you do not agree with any Terms
              contained herein you must immediately inform us.
            </li>
            <li className="m-3">
              Certain parts of this website may be subject to registration and
              additional terms and conditions which will be made available for
              you to read at the time of registration.
            </li>
            <li className="m-3">
              Unless otherwise indicated, this website and its contents are the
              property of Green. The copyright on the material contained on this
              website belongs to Green Publication or in the case of Open Access
              article to the licensors (Authors).
            </li>
            <li className="m-3">
              {" "}
              All articles published by Green Publication on this website marked
              "Open Access" are licensed by the respective authors of such
              articles for use and distribution by Green Publication subject to
              citation of the original source in accordance with the Open Access
              license (CC-BY 4.0).
            </li>
            <li className="m-3">
              {" "}
              You confirm that you have read and accept our Privacy Policy.{" "}
            </li>
            <li className="m-3">
              {" "}
              All content contained on or accessed from the website is owned by
              Green Publication or its licensors and is protected by copyright,
              trademark and other intellectual property and unfair competition
              laws.{" "}
            </li>
            <li className="m-3">
              {" "}
              We shall have the right, but not the obligation, to monitor
              submissions to determine compliance with these Terms and
              Conditions and any operating rules we establish and to satisfy any
              law, regulation or approve government request. We shall have the
              right in our sole discretion to edit, refuse to post or remove any
              Submission.{" "}
            </li>
            <li className="m-3">
              {" "}
              Green Publication reserves the right to change, modify, add or
              remove portions of these Terms and conditions as it sees fit,
              without notice. You agree to be bound by such amendments from the
              time at which they are displayed on the website.{" "}
            </li>
            <li className="m-3">
              {" "}
              We are not liable or responsible for the third party content on
              the website. Where the website and/or applications contain links
              to other sites and resources, which are provided by third parties,
              these links and resources are provided for your information only
              and you access them at your own risk.{" "}
            </li>
            <li className="m-3">
              {" "}
              Green Publication is not responsible for the content of any
              advertising material or any errors or inaccuracy in any
              advertising or sponsorship. Green Publication partners with
              third-party companies to serve ads and/or collect certain
              information when you visit the website.
            </li>
          </ol>
        </Row>
      </Container>
    </Layout>
  );
};

export default Terms;
